import React from 'react';

const topNavItems = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'manageCourses', label: 'Cursos' },
  { id: 'statistics', label: 'Estadisticas' },
  { id: 'communication', label: 'Comunicacion' }
];

const UdemyInstructorHeader = ({ activeTab, onTabChange }) => {
  const normalizedActiveTab = ['structure', 'film', 'upload', 'settings', 'publish', 'createNewCourse'].includes(activeTab)
    ? 'manageCourses'
    : activeTab;

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <div className="flex items-center">
              <h1 className="text-xl font-bold text-purple-600">EduDigital</h1>
              <span className="ml-2 text-sm bg-gray-100 px-2 py-1 rounded">Instructor</span>
            </div>
            <nav className="hidden md:flex space-x-2">
              {topNavItems.map((item) => {
                const isActive = normalizedActiveTab === item.id;

                return (
                  <button
                    key={item.id}
                    type="button"
                    onClick={() => onTabChange(item.id)}
                    className={`px-3 py-2 rounded-md font-medium transition-colors ${
                      isActive
                        ? 'bg-purple-100 text-purple-700'
                        : 'text-gray-700 hover:text-purple-600 hover:bg-purple-50'
                    }`}
                  >
                    {item.label}
                  </button>
                );
              })}
            </nav>
          </div>

          <div className="flex items-center space-x-4">
            <button className="p-2 text-gray-500 hover:text-purple-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
              </svg>
            </button>
            <button className="p-2 text-gray-500 hover:text-purple-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
              </svg>
            </button>
            <div className="relative">
              <button className="w-8 h-8 rounded-full bg-gray-300 overflow-hidden">
                <img
                  src="https://randomuser.me/api/portraits/men/32.jpg"
                  alt="Profile"
                  className="w-full h-full object-cover"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default UdemyInstructorHeader;
